module.exports = __webpack_public_path__ + "img/Ibukun-Awosika.19ca680e.jpg";